export default __webpack_public_path__ + "media/music/5497edaf79a9dfc0f89aba9a27d4e6a2.mp3";